import { render, staticRenderFns } from "./AppointmentsPatientModal.vue?vue&type=template&id=4ebf85ea&"
import script from "./AppointmentsPatientModal.vue?vue&type=script&lang=js&"
export * from "./AppointmentsPatientModal.vue?vue&type=script&lang=js&"
import style0 from "./AppointmentsPatientModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports